module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    },
    on: {
      "after-enter": _vm.afterEnter
    }
  }, [_c('div', {
    ref: "popup",
    staticClass: "popup",
    staticStyle: {
      "background-image": "url('static/img/main/point1/popup/bg.jpg')"
    }
  }, [_c('div', {
    staticClass: "popup-bg delay3"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-inner "
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left delay6"
  }, [_c('div', {
    staticClass: "quotes quotes-right"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                   Мне нравится местный климат, природа и культура. Обожаю испанские маленькие прибрежные города\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "point"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Аликанте, Испания\n                    ")])]), _vm._v(" "), _c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                        Аликанте — город "), _c('br'), _vm._v("светлого сияния\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                        Натуральная косметика Weleda сотрудничает с кооперативом, который управляет 6000 га органических миндальных рощ под Аликанте. Сборщики миндаля здесь отказались от интенсивного полива деревьев, так как искусственное орошение приводит к эрозии и засолению почвы.\n                        У этого решения, как у большинства экологических инициатив, есть цена: с одного гектара такой земли фермер получает всего 500 кг миндаля, что в десять раз меньше, чем, например, в Калифорнии, где практикуют «агрессивный» полив.\n                        Разницу в фермерском заработке компенсирует Weleda, для которой производство высококачественного органического миндального масла давно перестало быть всего лишь бизнесом.\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "right delay9"
  }, [_c('div', {
    staticClass: "popup-products"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', {
    staticClass: "head"
  }, [_vm._v("\n                            Миндаль\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                            Миндальное масло считается одним из самых ценных, применяемых в косметологии. Оно успокаивает раздраженную кожу, окутывает ее невесомым защитным слоем и увлажняет кожу.                        ")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BA%D1%80%D0%B0%D1%81%D0%BE%D1%82%D0%B0-%D0%BE%D1%82-%D0%BF%D1%80%D0%B8%D1%80%D0%BE%D0%B4%D1%8B/c%D1%8B%D1%80%D1%8C%D0%B5%D0%B2%D1%8B%D0%B5-%D0%BF%D1%80%D0%BE%D0%B5%D0%BA%D1%82%D1%8B/%D0%BC%D0%B8%D0%BD%D0%B4%D0%B0%D0%BB%D1%8C?utm_source=afisha&utm_medium=card&utm_content=almond&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('places', 'click', 'know more ')
      }
    }
  }, [_vm._v("\n                            Подробнее\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "img popup-products-img1"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point1/popup/product.png",
      "alt": ""
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e49ff5c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/popups/popup1.vue
// module id = 552
// module chunks = 1